import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import { useFlowLayoutMode } from '@/components/FlowTree/composables';

export default /*#__PURE__*/_defineComponent({
  __name: 'NotVisibleNode',
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as { type: 'loop' | 'branches' }


const ENTITY_MAP = {
	loop: {
		title: 'Loop',
		icon: 'loop',
	},
	branches: {
		title: 'Branch',
		icon: 'branches-small',
	},
};
const entity = computed(() => ENTITY_MAP[props.type]);
const { isNormalMode } = useFlowLayoutMode(useRouter(), useRoute());

return { __sfc: true,props, ENTITY_MAP, entity, isNormalMode }
}

})